import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function ProtectedCorporateRoute({ children }) {
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        setIsAuthorized(false);
        return;
      }

      // 🔹 Basit kontrol: email formatı ve localStorage
      const localData = localStorage.getItem("companyData");
      
      if (!localData) {
        setIsAuthorized(false);
        return;
      }

      try {
        const parsedData = JSON.parse(localData);
        
        // 🔹 Sadece email formatını kontrol et (@company.local)
        const userEmail = user.email;
        if (userEmail && userEmail.endsWith('@company.local')) {
          setIsAuthorized(true);
        } else {
          setIsAuthorized(false);
        }
      } catch (error) {
        console.error("Doğrulama hatası:", error);
        setIsAuthorized(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Yükleme durumu
  if (isAuthorized === null) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Yükleniyor...</p>
      </div>
    );
  }

  // Yetkisiz erişim
  if (!isAuthorized) {
    return <Navigate to="/login_corporate" replace />;
  }

  // Yetkili erişim
  return children;
}

const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#f7f9fb",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #0b63d6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  loadingText: {
    fontSize: "14px",
    color: "#666",
  },
};

// Spinner animation için inline CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);